class RegulationHelper {
  static instance = null;
  regulation_id = null;

  constructor() {
    if (RegulationHelper.instance) {
      return RegulationHelper.instance;
    }
    RegulationHelper.instance = this;
  }

  static getInstance() {
    if (!RegulationHelper.instance) {
      RegulationHelper.instance = new RegulationHelper();
    }
    return RegulationHelper.instance;
  }

  setRegulationId(id) {
    this.regulation_id = id;
  }

  getRegulationId() {
    return this.regulation_id;
  }
}

export default RegulationHelper;
